// Some browsers hand over a picked file with an empty `type` (e.g. iPhone HEIC photos on desktop
// browsers). supabase-js uploads a File as multipart form data, where Storage takes the type from
// the File itself - its `contentType` option is ignored for Files - so an empty type is stored as
// application/octet-stream, which the buckets' allowed types (image/*, video/*) reject.
// withUploadType gives such a file the type its extension implies; files that already have a type,
// or whose extension isn't listed, are returned unchanged.

const TYPE_BY_EXTENSION = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  heic: "image/heic",
  heif: "image/heif",
  mp4: "video/mp4",
  mov: "video/quicktime",
  m4v: "video/x-m4v",
  webm: "video/webm",
};

export function inferredUploadType(fileName) {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  return TYPE_BY_EXTENSION[ext] || null;
}

export function withUploadType(file) {
  if (!file || file.type) return file;
  const type = inferredUploadType(file.name);
  if (!type) return file;
  // Same bytes (a File built from another File references its data), new type.
  return new File([file], file.name, { type, lastModified: file.lastModified });
}
